import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from '@angular/core';
import {HROUTES} from '../horizontal-menu/navigation-routes.config';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {customAnimations} from '../animations/custom-animations';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfigService} from '../services/config.service';
import {Subscription} from 'rxjs';
import {LayoutService} from '../services/layout.service';
import {AuthService} from '../auth/auth.service';
import {LocalStorageService} from '../storage/local-storage.service';
import {QueryParamsServiceService} from '../query-params/query-params-service.service';
import {gql} from 'apollo-angular';
import {GraphQlService} from '../../services/graphQL/graph-ql.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ApolloError, ApolloQueryResult} from '@apollo/client/core';
import * as swalFunctions from '../data/sweet-alerts';

const moment = require('moment')

@Component({
  selector: 'app-sidebar',
  templateUrl: './vertical-menu.component.html',
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[] = [];
  level = 0;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  userData: any = {
    auth: {
      data: {}
    },
    organizationGroupList: [],
    doctorList: [],
    SelectedOrg: '',
    SelectedOrgGrp: '',
    moduleNames: [],
    patientList: [],
    StaffList: [],
    serviceList: [],
    dashboard: {},
    managerDashboard: {},
    timeOffList: [],
    overTime: [],
  };
  orgDetails: any;
  OrgGroup: any;
  modules: any;
  selectedPharmacy: any;
  pharmacyList = [];
  swal = swalFunctions;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private deviceService: DeviceDetectorService, private graphql: GraphQlService,
    private storage: LocalStorageService, private queryParams: QueryParamsServiceService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  resetParams() {
    this.queryParams.setParams({});
  }

  async ngOnInit() {
    this.OrgGroup = JSON.parse(localStorage.getItem('organizationGroup'));
    this.translate.use(localStorage.getItem('language') || 'en');
    await this.storage.getData('pulse-right').then(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    // Watch storage for changes
    this.storage.watchStorage().subscribe(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    if (window.location.pathname !== '/booking') {
      this.graphql.menusObs$.subscribe(menus => {
        console.log('VerticalMenuComponent received menuItems:', menus);
        this.menuItems = menus;
      });
      localStorage.setItem('organization', this.userData.SelectedOrg);
      if (this.userData.auth.data?.userType === 'Pharmacy Admin') {
        this.loadPharmacy();
      }
      this.authService.callOrganization.subscribe(async (orgResult: any) => {
        this.orgDetails = orgResult;
        await this.updateColors(orgResult);
      });
    }
  }

  async updateColors(organization) {
    const root = document.documentElement;
    root.style.setProperty('--primary-color-organization', organization.primaryColor);
    root.style.setProperty('--secondary-color-organization', organization.secondaryColor);

    if (this.userData.auth.data.role === 'Super Admin') {
      this.authService.MenuOptions.consultation = true;
      this.authService.MenuOptions.aptEnabled = true;
      this.authService.MenuOptions.pharmacybill = true;
      this.authService.MenuOptions.prescrption = true;
    } else {
      organization.modulesCost.map((module) => {
        if (module.name === 'Consultation Bill') {
          this.authService.MenuOptions.consultation = organization.modulesEnabled.includes(module.moduleId) && this.userData.auth.data.role === 'Admin';
        }
        if (module.name === 'Appointments') {
          this.authService.MenuOptions.aptEnabled = organization.modulesEnabled.includes(module.moduleId) && this.userData.auth.data.role === 'Admin';
        }
        if (module.name === 'Pharmacies') {
          this.authService.MenuOptions.pharmacybill = organization.modulesEnabled.includes(module.moduleId) &&
            ['Admin'].includes(this.userData.auth.data.role);
        }
        if (module.name === 'Prescription List') {
          this.authService.MenuOptions.prescrption = organization.modulesEnabled.includes(module.moduleId);
        }
      });
    }
  }

  loadPharmacy() {
    const QUERY = gql`
      query ListAllPharmacies($orgGrpId: ID, $orgId: ID, $status: String, $page: Int) {
        listAllPharmacies(orgGrpId: $orgGrpId, orgId: $orgId, status: $status, page: $page) {
          currentPage
          totalPages
          totalResults
          results {
            _id
            pharmacyName
            phoneNumber
            email
            logo
            organizationGroup
            organization
            deliveryType
          }
        }
      }`;
    const orgGroupStr = localStorage.getItem('organizationGroup');
    const organizationGroup = orgGroupStr ? JSON.parse(orgGroupStr)?.data : null;
    if (!organizationGroup?._id) {
      return;
    }
    const bodyInput = {
      'page': 1,
      'orgGrpId': organizationGroup._id,
      'orgId': this.userData.SelectedOrg,
      'status': 'true'
    };
    this.graphql.executeQuery(this.userData, QUERY, bodyInput).subscribe({
      next: (response: ApolloQueryResult<any> | any) => {
        const {listAllPharmacies} = response.data;
        this.pharmacyList = listAllPharmacies.results;
        this.selectedPharmacy = this.pharmacyList.find(pharmacy => pharmacy.organization.includes(this.userData.SelectedOrg));
        this.fetchPharmacyStats();
      }, error: (error: ApolloError | any | HttpErrorResponse) => {
      }
    });
  }


  fetchPharmacyStats() {
    // NOTE: orders-service's orderStatisticsByPharmacy no longer returns
    // `numberOfStaff`/`totalAmountWithDeliveryAndGST` (only totalOrders,
    // totalRevenue, statusCounts) — numberOfStaff has no backend equivalent
    // in the new schema and is left at 0; flagged for follow-up.
    const QUERY = gql`
      query OrderStatisticsByPharmacy($pharmacyId: ID!, $startDate: String!, $endDate: String!) {
        orderStatisticsByPharmacy(pharmacyId: $pharmacyId, startDate: $startDate, endDate: $endDate) {
          totalOrders
          totalRevenue
        }
      }`;

    const input = {
      'pharmacyId': this.selectedPharmacy._id,
      'startDate': moment(new Date()).format('YYYY-MM-DD'),
      'endDate': moment(new Date()).format('YYYY-MM-DD')
    }

    this.graphql.executeQuery(this.userData, QUERY, input).subscribe({
      next: (response: ApolloQueryResult<any> | any) => {
        const {orderStatisticsByPharmacy} = response.data;
        this.authService.pharmacyStatistics.numberOfStaff = 0;
        this.authService.pharmacyStatistics.orderCount = orderStatisticsByPharmacy.totalOrders;
      }, error: (error: ApolloError | any | HttpErrorResponse) => {
        this.authService.pharmacyStatistics.numberOfStaff = 0;
        this.authService.pharmacyStatistics.orderCount = 0;
      }
    });
  }


  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === 'Side') {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === 'Side') { // Vertical Menu{
      // this.menuItems = ROUTES;
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    } else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    const conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({layout: conf.layout});

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

}
